export function transformObject (inputObject) {
    return Object.keys(inputObject).reduce((transformedObject, key) => {
        transformedObject[key] = { first: inputObject[key] };
        return transformedObject;
    }, {});
}
